<template>
  <el-card>
    <el-form label-width="auto" ref="form" :model="formData">
      <el-form-item :label="$t('建议内容')">
        <div class="content-row">
          <p>{{formData.content || ""}}</p>
          <span>{{$t('建议日期')}}：{{ formData.createTime | formatDate }}</span>
        </div>
      </el-form-item>

      <el-form-item :label="$t('回复内容')">
        <div class="content-row">
          <el-input :placeholder="$t('回复内容')" v-model="formData.reply" />
          <span>{{$t('回复日期')}}：{{ releaseTime }}</span>
        </div>
      </el-form-item>

      <el-form-item :label="$t('图片')">
        <div class="img-row">
          <preview-img :size="60" :img-url="pic"  v-for="(pic, index) in formData.photoList"  :key="index"></preview-img>
        </div>
      </el-form-item>
      <el-form-item :label="$t('用户ID')">
        <span>{{ formData.userNum }}</span>
      </el-form-item>
      <el-form-item :label="$t('用户昵称')">
        <span>{{ formData.username }}</span>
      </el-form-item>
      <el-form-item :label="$t('联系方式')">
        <span>{{ formData.phone }}</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleConfirm">{{$t('确认')}}</el-button>
<!--        <el-button @click="resetForm" v-if="!formData.reply">重置</el-button>-->
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import {request} from "@/config/request";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
let timer = null;

export default {
  name: "SuggestEdit",
  components: {PreviewImg},
  data() {
    return {
      formData: {},
      releaseTime: null
    }
  },
  methods: {
    async handleConfirm() {
      try {
        const params = {
          code: this.formData.code,
          reply: this.formData.reply
        }
        await request(this.$api.suggestion.reply, params);
        this.$message.success(this.$t('操作成功'));
        this.$router.back();
      } catch (e) {
        console.log(e);
      }
    },

    // 重置表单
    resetForm() {
      this.$refs.form.resetFields();
    },

    async loadDetail() {
      try {
        const res = await request(this.$api.suggestion.detail, this.$route.query);
        const suggestion = res.suggestion;
        const photoList = suggestion.photo ? suggestion.photo.split(",") : [];
        suggestion.photoList = photoList.map(i => this.$api.file.downloadImg + i);
        this.formData = suggestion;
      } catch (e) {
        console.log(e);
      }
    },

    handleIntervalTime() {
      timer = setInterval(() => {
        this.releaseTime = this.$moment().format("YYYY-MM-DD HH:mm:ss");
      }, 1000)
    }
  },
  created() {
    this.loadDetail();
    this.handleIntervalTime();
    // 组件销毁关闭定时器
    this.$once('hook:beforeDestroy', () => {
      clearInterval(timer);
    })
  }

}
</script>

<style scoped>

.el-form {
  max-width: 800px;
}

.img-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.el-image {
  width: 90px;
  height: 90px;
}

.content-row {
  display: flex;
  flex-direction: column;
}

.content-row span {
  color: #999;
}

</style>
